import { Navigate, RouteObject } from 'react-router'
import { OperationsPage } from './pages/OperationsPage'
import { Paths } from '@/paths'
import { UserRole } from '@/application/auth/types/userRole'
import { App } from '@/App'
import { AppLayout } from '@/application/layouts/AppLayout'
import { ProfilePage } from '@/application/auth/pages/ProfilePage'
import { ProtectedRoute } from '@/application/auth/components/ProtectedRoute'
import { RoleProtectedRoute } from '@/application/auth/components/RoleProtectedRoute'
import { ForbiddenPage } from '@/application/auth/pages/ForbiddenPage'
import { ContractSearchPage } from '@/pages/ContractSearchPage'
import { ContractDetailsLayout } from '@/domain/contract/layouts/ContractDetailsLayout'
import { ContractMasterDataPage } from '@/domain/contract/pages/ContractMasterDataPage'
import { ContractTariffBookingsPage } from '@/domain/contract/pages/ContractTariffBookings'

export const getRoutes = async () => {
  const routes: RouteObject[] = [
    {
      path: '',
      Component: App,
      children: [
        {
          path: '',
          Component: ProtectedRoute,
          children: [
            {
              path: '',
              Component: AppLayout,
              children: [
                {
                  path: Paths.FORBIDDEN,
                  Component: ForbiddenPage
                },
                {
                  path: '',
                  element: <RoleProtectedRoute roles={[UserRole.Developer, UserRole.Reader]} />,
                  children: [
                    {
                      path: Paths.HOME,
                      element: <Navigate to={Paths.CONTRACTS_SEARCH} replace />
                    },
                    {
                      path: Paths.PROFILE,
                      Component: ProfilePage
                    },
                    {
                      path: Paths.OPERATIONS,
                      element: <RoleProtectedRoute roles={[UserRole.Developer]} />,
                      children: [
                        {
                          path: '',
                          Component: OperationsPage
                        }
                      ]
                    },
                    {
                      path: Paths.CONTRACTS_SEARCH,
                      Component: ContractSearchPage
                    },
                    {
                      path: Paths.CONTRACT_DETAILS,
                      Component: ContractDetailsLayout,
                      children: [
                        {
                          index: true,
                          element: <Navigate to={Paths.CONTRACT_MASTER_DATA} replace />
                        },
                        {
                          path: Paths.CONTRACT_MASTER_DATA,
                          Component: ContractMasterDataPage
                        },
                        {
                          path: Paths.CONTRACT_TARIFF_BOOKINGS,
                          Component: ContractTariffBookingsPage
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]

  return routes
}
